import {
  MESSAGE_SEND
} from '@actions/types'

export const sendSuggestionAction = ({ auth, data, messageGuid }) => ({
  type: MESSAGE_SEND,
  payload: {
    request: {
      method: 'post',
      url: `messages/${auth.hash}/${messageGuid}`,
      data,
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

